module.exports = __webpack_public_path__ + "media/images/v3/hero-thumb-e905ef58be8484899f1a9f386839502a.png";